export default __webpack_public_path__ + "static/media/Sabay_BW_H_1.dd022e86.png";